<script>
'use strict';

const imageHelpers = require('../../../../services/universal/image-helpers');
const dateFormat = require('date-fns/format');
const dateParse = require('date-fns/parse');
const gtm = require('../../../../services/client/gtm');
const analytics = require('../../lib/analytics');

module.exports = {
  name: 'StoryCard',
  props: {
    variation: {
      type: String,
      default: 'normal',
      validator: (val) => ['normal', 'recirc'].includes(val),
    },
    article: {
      type: Object,
      required: true,
    },
    position: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    cardClasses() {
      const variantMap = {
        normal: 'story-card-normal',
        recirc: 'story-card-recirc',
      };

      return ['story-card', variantMap[this.variation]];
    },
    showRubric() {
      return this.variation !== 'recirc';
    },
    showDate() {
      return true;
    },
    articleUrl() {
      const baseUrl = (this.article.canonicalUrl || '').replace('http://', 'https://');
      const { activeTab, searchValue } = this.$store.state;

      return analytics.buildArticleUrl(baseUrl, activeTab, searchValue);
    },
    imgUrl() {
      const rawUrl = this.article.feedImgUrl;

      if (!rawUrl) return '';
      const cleaned = imageHelpers.cleanUrl(rawUrl);
      const formatIndex = cleaned.lastIndexOf('.');
      const ext = cleaned.substring(formatIndex);
      const base = cleaned.substring(0, formatIndex);

      return `${base}.rsquare.w600${ext}`;
    },
    imgUrlRetina() {
      const rawUrl = this.article.feedImgUrl;

      if (!rawUrl) return '';
      const cleaned = imageHelpers.cleanUrl(rawUrl);
      const formatIndex = cleaned.lastIndexOf('.');
      const ext = cleaned.substring(formatIndex);
      const base = cleaned.substring(0, formatIndex);

      return `${base}.2x.rsquare.w600${ext} 2x`;
    },
    formattedDate() {
      if (!this.article.date) return '';
      const parsed = dateParse(this.article.date);
      const month = dateFormat(parsed, 'MMM');
      const day = dateFormat(parsed, 'D');
      const year = dateFormat(parsed, 'YYYY');

      return `${month} ${day}, ${year}`;
    },
  },
  methods: {
    onStoryClick() {
      const { activeTab, searchValue, productFilters } = this.$store.state;

      gtm.reportNow({
        event: 'article_click',
        article_click: {
          product_search_query: searchValue,
          product_search_budget: analytics.formatBudget(productFilters),
          product_search_variation: analytics.formatVariation(productFilters),
          component_name: 'augmented-search-results',
          component_type: analytics.formatTabName(activeTab),
          click_text: this.article.plaintextPrimaryHeadline,
          click_uri: this.article.canonicalUrl,
          position: this.position,
        },
      });
    },
  },
};
</script>

<template>
  <a :href="articleUrl" :class="cardClasses" @click="onStoryClick" target="_blank">
    <div class="story-card-image">
      <picture v-if="imgUrl">
        <source
          :srcset="imgUrlRetina"
          media="(min-resolution: 192dpi), (-webkit-min-device-pixel-ratio: 2)"
        />
        <img
          :src="imgUrl"
          :alt="article.plaintextPrimaryHeadline"
          class="story-card-img"
        />
      </picture>
    </div>
    <div class="story-card-details">
      <div class="story-card-meta" v-if="showRubric || showDate">
        <span v-if="showRubric && article.rubric" class="story-card-rubric">{{
          article.rubric
        }}</span>
        <span
          v-if="showRubric && article.rubric && showDate && formattedDate"
          class="story-card-meta-divider"
          >|</span
        >
        <span v-if="showDate && formattedDate" class="story-card-date">{{
          formattedDate
        }}</span>
      </div>
      <h3 class="story-card-headline">
        {{ article.plaintextPrimaryHeadline }}
      </h3>
    </div>
  </a>
</template>

<style scoped lang="postcss"></style>
